import { Skeleton } from '@shared/components/ui/shadcn';

export const FaqSkeleton = () => {
  return (
    <div className="space-y-4">
      <Skeleton className="h-5 w-40 bg-hover-press" />
      <div className="space-y-3">
        {[1, 2].map((item) => (
          <div key={item} className="flex items-center justify-between border-b border-card-border pb-3">
            <Skeleton className="h-4 w-72 bg-hover-press" />
            <Skeleton className="h-4 w-6 bg-hover-press" />
          </div>
        ))}
      </div>
    </div>
  );
};
